module.exports = __webpack_public_path__ + "img/fontUnderlineWhite.7163a6a4.svg";